const AuthenticationProviderType = {
    Application: 'Application',
    LDAP: 'LDAP',
    Windows: 'Windows', 
    Domain: 'Domain'
};

export default AuthenticationProviderType;